import type { BaseIconProps } from "@/assets/icons/utils";
import type { FC } from "react";

export const IconOperationsLog: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    {...props}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8.66667 1.66675H3V14.3334H13V6.00008M8.66667 1.66675L13 6.00008M8.66667 1.66675V6.00008H13M5.66667 9.00008H8.33333M5.66667 11.6667H10.3333"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    {...props}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g transform="translate(2,2)">
                        <path
                            d="M8.66667 1.66675H3V14.3334H13V6.00008M8.66667 1.66675L13 6.00008M8.66667 1.66675V6.00008H13M5.66667 9.00008H8.33333M5.66667 11.6667H10.3333"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                </svg>
            );
        case "lg":
            return (
                <svg
                    className={className}
                    {...props}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g transform="translate(4,4)">
                        <path
                            d="M8.66667 1.66675H3V14.3334H13V6.00008M8.66667 1.66675L13 6.00008M8.66667 1.66675V6.00008H13M5.66667 9.00008H8.33333M5.66667 11.6667H10.3333"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                </svg>
            );
    }
};
